import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useContext, useMemo } from "react";
import { browserTimeZone, effectiveTimeZone, } from "@sequentech/ui-core";
var EventTimeZoneContext = createContext(null);
/**
 * The election event whose screens are rendered below, so their times show
 * in its zones (VOTE-LIFECYCLE) without reading the event again. On an
 * election's screens, `election` makes them show in the election's zone.
 */
export var EventTimeZoneProvider = function (_a) {
    var event = _a.event, election = _a.election, children = _a.children;
    var value = useMemo(function () {
        var _a, _b;
        if (!(event === null || event === void 0 ? void 0 : event.id))
            return null;
        var presentation = ((_a = event.presentation) !== null && _a !== void 0 ? _a : null);
        return {
            id: String(event.id),
            presentation: presentation,
            zone: effectiveTimeZone(presentation, ((_b = election === null || election === void 0 ? void 0 : election.presentation) !== null && _b !== void 0 ? _b : null)),
        };
    }, [event === null || event === void 0 ? void 0 : event.id, event === null || event === void 0 ? void 0 : event.presentation, election === null || election === void 0 ? void 0 : election.presentation]);
    return _jsx(EventTimeZoneContext.Provider, { value: value, children: children });
};
/** The event of the screen, if it is rendered inside one. */
export var useZonedEvent = function () { return useContext(EventTimeZoneContext); };
var MyTimeZoneContext = createContext(null);
/**
 * "My time": the zone of the person looking, which is the browser's. Stories
 * and tests set it explicitly so they never depend on the machine's zone.
 */
export var MyTimeZoneProvider = function (_a) {
    var zone = _a.zone, children = _a.children;
    return _jsx(MyTimeZoneContext.Provider, { value: zone, children: children });
};
/** The viewer's zone: the one set above, else the browser's. */
export var useMyTimeZone = function () { var _a; return (_a = useContext(MyTimeZoneContext)) !== null && _a !== void 0 ? _a : browserTimeZone(); };
